/**
 * Inside the Case IDE, link the case company's rule labels ("Northwind 7")
 * in agent prose so they render as citations. Outside it, text passes through.
 */
import { useCallback } from "react";

import { useCaseIdeOptional } from "@/features/caseIde/context/CaseIdeContext";

import { linkRuleCitations } from "./playbookModel";
import { useCaseCompany } from "./queries";

export const useRuleCitations = (): ((text: string) => string) => {
  const ide = useCaseIdeOptional();
  const company = useCaseCompany(ide?.individualId || undefined).data?.company;
  return useCallback(
    (text: string) => linkRuleCitations(text, company),
    [company]
  );
};
